import React from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '../../../store/applicationStore';
import BlackLayer from '../blackLayer';

const MobileBigWinLayer = observer(() => {
  const { isShowMobileBigWinLayer } = applicationStore;

  return isShowMobileBigWinLayer ? <BlackLayer /> : null;
});
export default MobileBigWinLayer;
